import { NotificationsFilters, type NotificationsFiltersProps } from '@air/component-notifications';

export type MobileNotificationFooterProps = Required<Pick<NotificationsFiltersProps, 'filters' | 'onFilterClick'>>;

export const MobileNotificationFooter = ({ filters, onFilterClick }: MobileNotificationFooterProps) => {
  return (
    <footer className="shrink-0 border-t ads:border-t-default border-t-gray-5 px-1">
      <NotificationsFilters filters={filters} onFilterClick={onFilterClick} />
    </footer>
  );
};
